<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          <Input clearable
                 v-model="search.userId"
                 placeholder="用户id"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.nickname"
                 placeholder="昵称"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.realname"
                 placeholder="真实姓名"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.status"
                  :label-in-value="true"
                  placeholder="状态"
                  class="select"
          >
            <Option value="-1" label="提现失败"></Option>
            <Option value="1" label="申请提现"></Option>
            <Option value="10" label="提现成功"></Option>
          </Select>
        </div>
        <!-- 日期范围选择 -->
        <div class="search-item">
          <DatePicker
              type="daterange"
              v-model="search.dateRange"
              placeholder="选择日期范围"
              style="width: 200px"
          ></DatePicker>
        </div>

        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
        <!-- 导出按钮 -->
        <Button
            style="width: 80px;margin-bottom:5px"
            type="primary"
            icon="ios-download-outline"
            @click="exportData"
        >导出
        </Button>
      </div>
    </div>
    <!-- 提现总金额展示 -->
    <div class="total-amount">
      <span class="label">提现总金额：</span>
      <span class="amount">{{ totalCashOut }}</span>
      <span class="unit">元</span>
    </div>
    <!-- 提现统计点击区域 -->
    <div class="cashout-statistics" @click="goToStatistics">
      提现统计
    </div>
    <div class="table">
      <Table
          :columns="diyData.columns"
          :data="apiData.tableList"
      >
        <template slot="footer">
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
          ></Page>
        </template>
      </Table>
    </div>
    <Modal v-model="showModal" :mask="false" title="提现审核">
      <Form :model="ensureForm" :label-width="100">
        <FormItem label="审核结果">
          <RadioGroup v-model="ensureForm.result">
            <Radio label="success">标记成功</Radio>
            <Radio label="failed">标记失败</Radio>
            <Radio label="auto">自动转账</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注">
          <Input v-model="ensureForm.comments" type="textarea" :rows="4" placeholder="请输入备注"/>
        </FormItem>
      </Form>
      <template #footer>
        <Button type="primary" @click="submitEnsure">提交</Button>
        <Button @click="showModal = false">取消</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import {apiCashoutlogExport, apiCashoutlogList, apiCashoutOpt} from '@/api/withdrawal-manage.js'
import {getDateTime} from '@/libs/util'

export default {
  name: 'withdrawal-manage',
  data() {
    return {
      showModal: false,
      ensureForm: {
        cashOutNo: '',
        result: 'success', // 默认选中"标记成功"
        comments: '' // 备注内容},
      },
      query: {},
      totalCashOut: 0,
      search: {
        cashOutNo: '',
        userId: '',
        nickname: '',
        trancId: '',
        realname: '',
        phone: '',
        status: '',
        pageNo: 1,
        pageSize: 10,
        dateRange: [] // 日期范围
      },
      diyDom: {
        showModal: false
      },
      diyData: {
        columns: [
          {
            title: '流水号',
            key: 'cashOutNo',
            width: '200px'
          },
          {
            title: '昵称-ID',
            width: '150px',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.search.userId = params.row.userId,
                          this.searchFn()
                    }
                  }
                }, params.row.nickname + '-' + params.row.userId)
              ])
            }
          },
          {
            title: '手机号',
            width: '140px',
            key: 'phone'
          },
          {
            title: '真实姓名',
            width: '100px',
            key: 'realname'
          },
          {
            title: '提现金额',
            width: '100px',
            key: 'amount'
          },
          {
            title: '积分余额',
            width: '100px',
            key: ''
          },
          {
            title: '状态',
            width: '100px',
            key: 'status',
            render: (h, params) => {
              switch (params.row.status) {
                case -1:
                  return h('span', {
                    style: {color: '#808080'}
                  }, '提现失败')
                case 1:
                  return h('p', {
                    style: {color: '#FF5733'}
                  }, '申请提现')
                case 2:
                  return h('p', {
                    style: {color: '#2a9de4'}
                  }, '待领取')
                case 10:
                  return h('p', {
                    style: {color: '#2A82E4'}
                  }, '提现成功')
              }
            }
          },
          {
            title: '微信状态',
            key: 'wxStatus',
            width: '120px'
          },
          {
            title: '备注',
            key: 'comments',
            width: '250px'
          },
          {
            title: '微信提现单号',
            key: 'trancId',
            width: '200px'
          },
          {
            title: '申请/处理时间',
            width: '200px',
            render: (h, params) => {
              return h('div', [
                h('p', getDateTime(params.row.createTime)),
                h('p', getDateTime(params.row.completeTime))
              ])
            }
          },
          {
            title: '操作',
            width: '150px',
            fixed: 'right',
            render: (h, params) => {
              var display = 'none'
              if (params.row.status === 1 ||
                  params.row.status === 2
              ) {
                display = ''
              }
              return h('div', [
                h('Button', {
                      props: {
                        size: 'small'
                      },
                      style: {
                        marginRight: '10px',
                        fontSize: '14px',
                        display: display
                      },
                      on: {
                        click: () => {
                          this.ensureForm.cashOutNo = params.row.cashOutNo
                          this.showModal = true
                        }
                      }
                    },
                    '审核'
                ),
                h('Button', {
                      props: {
                        size: 'small'
                      },
                      style: {
                        marginRight: '10px',
                        fontSize: '14px'
                      },
                      on: {
                        click: () => {
                          sessionStorage.setItem('search', JSON.stringify(this.search))
                          this.$router.push({
                            name: 'points-details',
                            query: {
                              userId: params.row.userId
                            }
                          })
                        }
                      }
                    },
                    '查看记录'
                )

              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        tableList: []
      }
    }
  },
  methods: {
    // 跳转到提现统计页面
    goToStatistics() {
      this.$router.push({
        name: 'cashout-statistics'  // 确保路由配置中存在此名称
      })
    },
    submitEnsure() {
      // 如果是标记失败，则备注必填
      if (this.ensureForm.result === 'failed' && !this.ensureForm.comments.trim()) {
        this.$Message.error('请填写备注')
        return
      }

      // 其他提交逻辑可以在这里添加
      console.log('提交审核表单:', this.ensureForm)
      apiCashoutOpt(this.ensureForm).then(res => {
        console.log('提交审核表单响应:', res)
        console.log('提交审核表单响应code:', res.code)
        console.log('提交审核表单响应msg:', res.msg)
        if (res.code == 200) {
          this.$Message.success('操作成功')
          this.getTableList()
          // 这里应该调用API提交数据
          this.showModal = false
        } else {
          this.$Message.error(res.msg)
        }
      })

      // 提交成功后关闭模态框
    },
    // 分页
    pageChange(e) {
      this.search.pageNo = e
      this.getTableList()
    },
    pageSizeChange(e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn() {
      this.search.pageNo = 1
      this.getTableList()
    },
    getTableList() {
      this.$store.commit('setSpinShow', true)
      var opt = {...this.search, ...this.query}
      // 处理日期范围参数
      if (this.search.dateRange && this.search.dateRange.length === 2) {
        opt.dateStart = getDateTime(this.search.dateRange[0])
        opt.dateEnd = getDateTime(this.search.dateRange[1])
      }
      delete opt.dateRange
      apiCashoutlogList(opt).then((res) => {
        const {
          list,
          totalCount,
          data
        } = res.data

        this.apiData.tableList = list
        this.apiData.total = totalCount
        this.totalCashOut = data
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
    // 导出数据处理
    exportData() {
      var opt = {...this.search, ...this.query}

      // 处理日期范围参数
      if (this.search.dateRange && this.search.dateRange.length === 2) {
        opt.createTimeBegin = getDateTime(this.search.dateRange[0])
        opt.createTimeEnd = getDateTime(this.search.dateRange[1])
      }
      delete opt.dateRange

      this.$store.commit('setSpinShow', true)
      apiCashoutlogExport({...this.search}).then(res => {
        // this.diyDom.showExport = false
        const {data} = res
        const blob = new Blob([data])
        let disposition = decodeURI(res.headers['content-disposition'])
        // 从响应头中获取文件名称
        let fileName = disposition.substring(disposition.indexOf('fileName=') + 22, disposition.length)
        let text = fileName
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = text.substring(0, text.length - 1)
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
          .finally(() => this.$store.commit('setSpinShow', false))
    }
  },
  mounted() {
    this.query = this.$route.query
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

/* 提现总金额样式 */
.total-amount {
  margin: 10px 0 0;
  padding: 3px 15px;
  background-color: #f0f8ff;
  border: 1px solid #d0e9ff;
  border-radius: 4px;
  display: inline-block;

  .label {
    font-weight: bold;
    color: #333;
    font-size: 14px;
  }

  .amount {
    font-size: 18px;
    font-weight: bold;
    color: #ff6600;
    margin: 0 5px;
  }

  .unit {
    color: #666;
    font-size: 14px;
  }
}

.button-border {
  margin-right: 10px;
}

.cashout-statistics {
  line-height: 27px;
  font-size: 18px;
  margin: 10px 10px 0;
  padding: 3px 15px;  // 修改为与 .total-amount 相同的 padding
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: inline-block;
  cursor: pointer;
  color: #337ab7;
  font-weight: bold;

  &:hover {
    background-color: #e6e6e6;
    color: #23527c;
  }
}
</style>
